import React, { useEffect, useState } from "react";
import styles from "./promotion(n+n+n).scss";
import {
  batchAddToCart,
  calculateBundleTotal,
} from "../../../../common/utils/apis";
import { useSelector, useDispatch } from "react-redux";
import Cartbtn from "@tw/shared-ui-components/lib/components/addToCartButton/cartBtn";
import APlusBZone from "../aPlusBZone/aPlusBZone";
import GrandTotal from "../grandTotal/grandTotal";
import BundleWrapper from "../bundleWrapper/bundleWrapper";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";
import Strings from '@tw/shared-ui-components/lib/utils/locale'
import { updateCartDetails } from "@tw/header-footer/lib/redux/reducers";
import { M_PLUS_N_BUNDLE } from "../../../../common/constant";
import {
  trackAddToCart,
  ttqTrackEventBuryingPoint,
  trackProductViewList,
  PAGES,
} from "@tw/shared-ui-components/lib/utils/analytics";
import { getPageDetails } from "../../../../common/utils/helper";
import SEOHead from "../../../../common/components/seoHead/seoHead";

export default function PromotionNplusNplusN(props) {
  const { Link, NextHead, template } = props;
  const dispatch = useDispatch();
  const promotionDetails = useSelector(
    (state) => state?.plpState?.promotionDetails
  );

  const promotionTitle = useSelector((state) => state?.plpState?.title);

  const zones = useSelector(
    (state) => state?.plpState?.promotionProducts?.zones
  );

  const initialGrandTotal = {
    totalPrice: 0,
    totalPointVolume: 0,
    totalBusinessVolume: 0,
  };
  const [grandTotal, setGrandTotal] = useState(initialGrandTotal);

  const [isLoading, setIsLoading] = useState(false);
  const [isAddToCartLoading, setIsAddToCartLoading] = useState(false);
  const [loadingProduct, setLoadingProduct] = useState(null);

  const pageDetails = getPageDetails(null, PAGES.promotion);

  const getInitialQuantities = () =>
    zones?.map((zone) =>
      zone?.products?.reduce(
        (initialQuantities, product) => ({
          ...initialQuantities,
          [product.itemCode]: 0,
        }),
        {}
      )
    );

  const [quantities, setQuantities] = useState(getInitialQuantities);

  const totalQuantity = quantities.reduce(
    (total, zoneQuantities) =>
      total +
      Object.values(zoneQuantities).reduce((t, quantity) => t + quantity, 0),
    0
  );

  const getSelectedProducts = (selectedQuantities) =>
    selectedQuantities
      .reduce(
        (list, zoneQuantities) => [
          ...list,
          ...Object.entries(zoneQuantities).map(([itemCode, quantity]) => ({
            itemCode,
            quantity,
          })),
        ],
        []
      )
      .filter((item) => item.quantity > 0);

  const updateQuantities = async (newQuantities) => {
    const promotionItemList = getSelectedProducts(newQuantities);

    if (!promotionItemList?.length) {
      setQuantities(newQuantities);
      setGrandTotal(initialGrandTotal);
      return;
    }

    setIsLoading(true);
    try {
      const total = await calculateBundleTotal(
        promotionDetails?.promotionCode,
        promotionItemList
      );
      if (total?.code && total?.message) {
        toastMsg(total?.message);
        setIsLoading(false);
        setLoadingProduct(null);
      } else {
        setQuantities(newQuantities);
        setGrandTotal(total);
        setIsLoading(false);
        setLoadingProduct(null);
      }

    } catch (err) {
      console.log(err);
      toastMsg(err?.response?.data?.message || err?.message);
      setIsLoading(false);
      setLoadingProduct(null);
    }
  };

  const onItemQuantityChange = (zoneIndex) => (itemCode, quantity) => {
    setLoadingProduct(itemCode);
    updateQuantities(
      quantities.map((zoneQuantities, i) =>
        i === zoneIndex
          ? { ...zoneQuantities, [itemCode]: quantity }
          : zoneQuantities
      )
    );
  };

  const onAddToCart = async () => {
    const products = getSelectedProducts(quantities);
    try {
      setIsAddToCartLoading(true);
      const res = await batchAddToCart(products);
      if (res.status === 200) {
        const allProducts = zones?.reduce(
          (arr, zone, zoneIndex) => [
            ...arr,
            ...(zone?.products || [])
              .map((product) => ({
                product,
                quantity: quantities?.[zoneIndex]?.[product?.itemCode],
              }))
              .filter((product) => !!product.quantity),
          ],
          []
        );
        /*  ===============================================  TEP-15578 ============================================= */
        const productItem = zones?.reduce(
          (arr, zone, zoneIndex) => [
            ...arr,
            ...(zone?.products || [])
              .map((product) => ({
                ...product,
                quantity: quantities?.[zoneIndex]?.[product?.itemCode],
              }))
              .filter((product) => !!product.quantity),
          ],
          []
        );
        ttqTrackEventBuryingPoint('addToCart', productItem)
        /*  ===============================================  TEP-15578 ============================================= */

        // tealium analytics
        trackAddToCart(
          allProducts?.map((product) => product?.product),
          allProducts?.map((product) => product?.quantity),
          pageDetails
        );
        await dispatch(
          updateCartDetails({
            id: M_PLUS_N_BUNDLE,
            totalQuantity: res?.data?.data?.totalQuantity,
            products: allProducts,
          }, 2)
        );
      } else {
        const { msgData, message } = res?.response?.data;
        if (msgData && msgData.length > 0) {
          const allProducts = msgData.map((product) => product.skuCode)
          const productItem = zones?.reduce(
            (arr, zone, zoneIndex) => [
              ...arr,
              ...(zone?.products || [])
                .map((product) => ({
                  ...product,
                  quantity: quantities?.[zoneIndex]?.[product?.itemCode],
                }))
                .filter((product) => !!product.quantity),
            ],
            []
          );
          const productNames = productItem && productItem.length > 0 && productItem.filter(obj => allProducts.includes(obj?.itemCode)).map(obj => obj?.productName);
          const stringResult = productNames && productNames.length > 0 && productNames.map(item => `【${item}】`).join('');
          toastMsg(Strings.PRODUCT_LOW_STOCKS.replace(/productNames/g, stringResult));
        } else {
          toastMsg(message);
        }
      }

      setQuantities(getInitialQuantities());
      setGrandTotal(initialGrandTotal);
      setIsAddToCartLoading(false);
    } catch (err) {
      toastMsg(err?.response?.data?.message || err?.message);
      console.log(err);
      setIsAddToCartLoading(false);
    }
  };

  const canAvailGift = () =>
    zones.every((zone, i) => {
      const selectedZoneQuantity = Object.values(quantities[i]).reduce(
        (total, quantity) => total + quantity,
        0
      );
      return zone.quantity <= selectedZoneQuantity;
    });

  const getWarningMsg = () => {
    // const zoneQuantityMapping = zones
    //   .map((zone, i) => `${zone.quantity} 区 ${i + 1}`)
    //   .join(" 和 ");

    // const defaultWarningMsg = `购买 ${zoneQuantityMapping} 产品可获赠礼品`;
    const defaultWarningMsg = `購買A區和B區產品可獲贈贈品`;

    const warningMessage =
      promotionDetails?.warningMessage || defaultWarningMsg;

    return (
      <>
        <span style={{ color: promotionDetails?.warningMessageColor }}>{warningMessage}</span>{" "}
        {promotionDetails?.warningMessageUrl && (
          <a
            className={styles.link}
            target="_blank"
            href={promotionDetails?.warningMessageUrl}
            rel="noreferrer"
          >
            詳情
          </a>
        )}
      </>
    );
  };

  const renderGrandTotal = () => <GrandTotal grandTotal={grandTotal} template={template} />;

  const renderFooter = () => (
    <div className={styles["add-to-cart-wrapper"]}>
      <Cartbtn
        cartText="加入購物車"
        onAddToCart={onAddToCart}
        disableAddToCart={!totalQuantity}
        displayCartIcon={false}
        isLoading={isAddToCartLoading}
      />
    </div>
  );

  // tealium analytics
  useEffect(() => {
    // TEAL-2330
    let timer;
    if (typeof window !== 'undefined' && typeof window !== undefined) {
      let times = 0;
      timer = setInterval(async () => {
        if (window?.utag && zones) {
          await clearInterval(timer)
          await trackProductViewList({
            products: zones?.reduce(
              (arr, zone) => [
                ...arr,
                ...(zone?.products || []).map((product) => ({
                  ...product,
                  promotionCode: promotionDetails?.promotionCode,
                })),
              ],
              []
            ),
            page: pageDetails,
          });
        } else {
          if (times >= 20) {
            await clearInterval(timer)
          }
          times++
        }
      }, 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [zones]);

  return (
    <>
      <SEOHead NextHead={NextHead} seoConfig={{ pageTitle: promotionTitle }} />
      <BundleWrapper
        Link={Link}
        renderFooter={renderFooter}
        renderGrandTotal={renderGrandTotal}
      >
        {!canAvailGift() && (
          <div className={styles["warning"]}>
            <span className={styles["icon"]}>
              <WarningIcon />
            </span>
            <span className={styles["message"]}>{getWarningMsg()}</span>
          </div>
        )}
        <div className={styles["set_container"]}>
          {zones?.map((zone, index) => (
            <APlusBZone
              zone={zone}
              key={index}
              quantities={quantities[index]}
              onItemQuantityChange={onItemQuantityChange(index)}
              disableButtons={isLoading}
              loadingProduct={loadingProduct}
            />
          ))}
        </div>
      </BundleWrapper>
    </>
  );
}

const WarningIcon = (props) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 0.5625C3.71875 0.5625 0.25 4.0625 0.25 8.3125C0.25 12.5938 3.71875 16.0625 8 16.0625C12.25 16.0625 15.75 12.5938 15.75 8.3125C15.75 4.0625 12.25 0.5625 8 0.5625ZM8 14.5625C4.53125 14.5625 1.75 11.7812 1.75 8.3125C1.75 4.875 4.53125 2.0625 8 2.0625C11.4375 2.0625 14.25 4.875 14.25 8.3125C14.25 11.7812 11.4375 14.5625 8 14.5625ZM8 4C7.25 4 6.6875 4.59375 6.6875 5.3125C6.6875 6.0625 7.25 6.625 8 6.625C8.71875 6.625 9.3125 6.0625 9.3125 5.3125C9.3125 4.59375 8.71875 4 8 4ZM9.75 11.9375V11.1875C9.75 11 9.5625 10.8125 9.375 10.8125H9V7.6875C9 7.5 8.8125 7.3125 8.625 7.3125H6.625C6.40625 7.3125 6.25 7.5 6.25 7.6875V8.4375C6.25 8.65625 6.40625 8.8125 6.625 8.8125H7V10.8125H6.625C6.40625 10.8125 6.25 11 6.25 11.1875V11.9375C6.25 12.1562 6.40625 12.3125 6.625 12.3125H9.375C9.5625 12.3125 9.75 12.1562 9.75 11.9375Z"
      fill="#A36A00"
    />
  </svg>
);
